App.factory('responseFactory', responseFactory);

responseFactory.$inject = [
    'DispatcherService'
];

function responseFactory(DispatcherService) {
    return {
        query: function() {
            return DispatcherService.get('responses');
        },

        summary: function(code) {
            return DispatcherService.get('responses/' + code + '/summary');
        },

        responses: function(code, surveyType) {
            var uri = 'responses/' + code + '/responses';

            if (surveyType == 'pre' || surveyType == 'post') {
                uri += '?surveyType='+surveyType;
            }

            return DispatcherService.get(uri);
        },

        updateResponse: function(code, response) {
            return DispatcherService.put('responses/' + code + '/responses/' + response.id, response );
        },

        freeResponses: function(code) {
            return DispatcherService.get('responses/' + code + '/responses/free-response-answers');
        },

        destroyResponse: function(code, response) {
            return DispatcherService.delete('responses/' + code + '/responses/' + response.id);
        },

        answers: function(code, response_id) {
            return DispatcherService.get('responses/' + code + '/responses/' + response_id + '/answers');
        },

        updateAnswer: function(code, answer) {
            return DispatcherService.put('responses/' + code + '/responses/' + answer.response_id + '/answers/' + answer.id, answer);
        }
    };
}
